'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
  An NavigationSort component
  ```jsx_example
  ```
 **/
// TODO: return value along with selected
var NavigationSort = function (_Component) {
  _inherits(NavigationSort, _Component);

  function NavigationSort(props) {
    _classCallCheck(this, NavigationSort);

    var _this = _possibleConstructorReturn(this, (NavigationSort.__proto__ || Object.getPrototypeOf(NavigationSort)).call(this, props));

    _this.styles = require('./NavigationSort.scss');
    _this.state = {
      items: []
    };
    _this.state.items = _this.getInitData();
    return _this;
  }

  _createClass(NavigationSort, [{
    key: 'getInitData',
    value: function getInitData() {
      var items = this.props.items;

      var itemsData = [];
      items.forEach(function (item) {
        var itemData = { name: item.name, value: item.value, selected: item.selected };
        if (item.sort) {
          itemData.sort = 'asc';
        }
        itemsData.push(itemData);
      });
      return itemsData;
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      var _this2 = this;

      var DATA = [];
      this.state.items.forEach(function (item) {
        DATA.push(_react2.default.createElement(
          'span',
          { onClick: _this2.handleSelect.bind(_this2, item), className: _this2.styles.sort_item, style: item.selected ? { border: '1px #666 solid' } : {} },
          item.name,
          item.sort === 'asc' ? _react2.default.createElement('i', { className: 'fa fa-caret-up' }) : _react2.default.createElement('i', { className: 'fa fa-caret-down' })
        ));
      });
      return DATA;
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(selectedItem) {
      var onClick = this.props.onClick;

      this.state.items.forEach(function (item) {
        if (item.value === selectedItem.value) {
          item.selected = true;
          if (item.sort) {
            item.sort = item.sort === 'asc' ? 'desc' : 'asc';
          }
          if (onClick) {
            onClick(selectedItem);
          }
        } else {
          item.selected = false;
        }
      });
      this.setState({ items: this.state.items });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'p',
        null,
        this.getItems()
      );
    }
  }]);

  return NavigationSort;
}(_react.Component);

NavigationSort.propTypes = {
  items: _propTypes2.default.array,
  style: _propTypes2.default.object,
  onClick: _propTypes2.default.func
};
NavigationSort.defaultProps = {
  items: [],
  style: {}
};
exports.default = NavigationSort;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/NavigationSort/NavigationSort.js
// module id = 2135
// module chunks = 1